<div class="time-period input-group form-group-sm flex-nowrap mr-2" ngbDropdown [autoClose]="true" #timeSelect="ngbDropdown">
  <!--<div ngbDropdownToggle class="btn btn-outline-theme btn-block d-flex align-items-center text-start btn-sm">
    <span class="text-truncate">{{displayName}}</span>
  </div>-->
  <div class="input-group flex-nowrap input-group-sm">
    <span ngbDropdownToggle id="ddlTimeSelect" class="input-group-text"></span>


    <input *ngIf="type == 'text'" type="text" [(ngModel)]="period" class="time-text form-control form-select-sm" (change)="change()" />
    <!--<button *ngIf="type == 'text'" class="btn btn-sm btn-default time-help form-select-sm" type="button" (click)="this.openHelpModal()">
        <i class="fa fa-info"></i>
    </button>-->

    <input *ngIf="type=='daterange'" type="date" class="form-control" name="start" placeholder="Start" [(ngModel)]="fromDate"
      (ngModelChange)="changeDates(0)" [ngClass]="{'is-invalid': dateTimeInvalid}"/>
    <span *ngIf="type=='daterange'" class="input-group-text">to</span>
    <input *ngIf="type=='daterange'" type="date" class="form-control" name="end" placeholder="End" [(ngModel)]="toDate"
      (ngModelChange)="changeDates(1)" [ngClass]="{'is-invalid': dateTimeInvalid}" />

    <input *ngIf="type=='template'" type="text" class="form-control" placeholder="Time Period" [(ngModel)]="displayName" ngbDatepicker  [bsConfig]="bsConfig" (blur)="changeDates(0)" (change)="changeDates(0)" (keyup)="changeDates(0)"/>
  </div>
  <div ngbDropdownMenu class="row time-period-selector" aria-labelledby="ddlTimeSelect">
    <!--<div class="profile">
      <div class="profile-container">
        <div class="profile-sidebar">-->
          <ul class="list-group list-group-flush">
            <li class="list-group-item" ngbDropdownItem (click)="selectTemplate(template)" [ngClass]="{'selected':selectedItem != null && selectedItem.value == template.value}" *ngFor="let template of templateItems">{{template.name}}</li>
            <!--<li class="list-group-item seperator"></li>-->
            <hr/>
            <!--<li class="list-group-item" ngbDropdownItem (click)="type = 'rangeselect'"><i class="fa fa-arrows-h"></i> Range Select</li>-->
            <li class="list-group-item" ngbDropdownItem (click)="type = 'daterange'"><i class="fa fa-calendar"></i> Date Range</li>
            <li class="list-group-item" ngbDropdownItem (click)="type = 'text'"><i class="fa fa-code"></i> Text</li>
          </ul>
        <!--</div>
        <div class="profile-content">
        THERE
        </div>
      </div>
    </div>-->
  </div>
</div>
<br/>


<!--<div class="time-period">
  <table>
    <tr>
      <td width="30%">
        <select [(ngModel)]="type" class="time-type form-select form-select-sm" (change)="change()">
          <option value="template">Template</option>
          <option value="relative">Relative</option>
          <option value="dates">Date Range</option>
          <option value="text">Text</option>
        </select>
      </td>
      <td width="70%">
        <select [(ngModel)]="period" class="time-other form-select form-select-sm" (change)="change()" *ngIf="type == 'template'">
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="thisWeek">This Week</option>
          <option value="lastWeek">Last Week</option>
          <option value="thisMonth">This Month</option>
          <option value="lastMonth">Last Month</option>
          <option value="thisQuarter">This Quarter</option>
          <option value="lastQuarter">Last Quarter</option>
          <option value="thisYear">This Year</option>
          <option value="lastYear">Last Year</option>
        </select>

        <div *ngIf="type == 'relative'" class="input-group">
          <input type="text" [(ngModel)]="from" class="time-relative form-control form-select-sm" (change)="changeRelative()" />
          <select [(ngModel)]="fromType" class="time-relative form-select form-select-sm" (change)="changeRelative()">
              <option value="h">Hour</option>
              <option value="d">Day</option>
              <option value="m">Month</option>
              <option value="y">Year</option>
          </select>
          <input  type="text" [(ngModel)]="to" class="time-relative form-control form-select-sm" (change)="changeRelative()" />
          <select  [(ngModel)]="toType" class="time-relative form-select form-select-sm" (change)="changeRelative()">
              <option value="h">Hour</option>
              <option value="d">Day</option>
              <option value="m">Month</option>
              <option value="y">Year</option>
          </select>
        </div>  

        <input *ngIf="type == 'text2'" type="text" [(ngModel)]="period" class="time-text form-control form-select-sm" (change)="change()" />
        <button *ngIf="type == 'text2'" class="btn btn-sm btn-default time-help form-select-sm" type="button" (click)="this.openHelpModal()">
            <i class="fa fa-info"></i>
        </button>

        <div *ngIf="type == 'text'" class="input-group">
          <input [(ngModel)]="period" class="form-control time-text form-select-sm" (change)="change()" id="textpicker" />
          <label class="input-group-text time-help form-select-sm" for="textpicker" (click)="this.openHelpModal()">
            <i class="fa fa-info"></i>
          </label>
        </div>
        
        <div *ngIf="type == 'dates'" class="input-group">
          <input *ngIf="type == 'dates'" type="text" [(ngModel)]="fromDate" placeholder="From Date" class="time-date form-control form-select-sm" bsDatepicker [bsConfig]="bsConfig" (blur)="changeDates(0)" (change)="changeDates(0)" (keyup)="changeDates(0)"/>
          <input *ngIf="type == 'dates'" type="text" [(ngModel)]="toDate"   placeholder="To Date"   class="time-date form-control form-select-sm" bsDatepicker [bsConfig]="bsConfig" (blur)="changeDates(1)" (change)="changeDates(1)" (keyup)="changeDates(1)"/>
        </div>

      </td>
      <td>
    </tr>
  </table>
</div>-->

<!-- Modal -->
<div class="modal fade" bsModal #helpModal="bs-modal" tabindex="-1" role="dialog" (onHidden)="closeHelpModal()">
    <div class="modal-dialog bg-bg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-left">Time Period - Help Information</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="closeHelpModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <article>
                    <p>1. Free Text e.g. -2d:1h</p>
                    <p>Description: You are selecting 2 days in the past, 1 hour into the future as the time period</p>
                    <p>2. Template e.g. thisWeek</p>
                    <p>Description: You are selecting this week as the time period</p>

                    <section>
                        <h4>Available Units:</h4>
                        <div>s - seconds</div>
                        <div>h - hours</div>
                        <div>d - days</div>
                        <div>w - weeks</div>
                        <div>m - month</div>
                    </section>
                    <br>
                    <section>
                      <h4>Available Templates:</h4>
                      <table class="table">
                        <tr>
                          <th>Relative</th><th>Unit</th>
                        </tr>
                        <tr>
                          <td colspan="2">today</td>
                        </tr>
                        <tr>
                          <td colspan="2">yesterday</td>
                        </tr>
                        <tr>
                          <td rowspan="2">this</td><td>Day | Week | Month | Year | Quarter</td>
                        </tr>
                        <tr>
                          <td>WeekStartingMonday | WeekStartingSaturday</td>
                        </tr>
                        <tr>
                          <td rowspan="7">last</td><td>Day | Week | Month | Year | Quarter</td>
                        </tr>
                        <tr>
                          <td>WeekStartingMonday | WeekStartingSaturday</td>
                        </tr>
                      </table>
                    </section>
                </article>

            </div>
            <div class="modal-footer">
                <button class="btn btn-default" type="button" (click)="closeHelpModal()">Cancel</button>
            </div>
        </div>
    </div>
</div>
